<form class="m-form" novalidate autocomplete="off">
    <label *ngIf="label">{{'modulos.materiais-didaticos.tipo-livro' | translate}}</label>
    <ng-select bindValue="id" bindLabel="nome" name="tipos" [placeholder]="'modulos.materiais-didaticos.livros-didatico' | translate" [ngClass]="class" [clearable]="false"
        [notFoundText]="'modulos.materiais-didaticos.nenhum-livro' | translate" [(ngModel)]="tipoLivro" [items]="tiposLivro" (change)="onSelect($event)"></ng-select>
</form>
